export default class AdminLabReports {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/lab`, {
      params
    })
  }

  getChart(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/lab/chart`, {
      params
    })
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/lab/export`, {
      params,
      responseType: "blob"
    })
  }

  listCategories(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/lab/category-list`, {
      params
    })
  }

  listTypes(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/lab/type-list`, {
      params
    })
  }
}
